import { render, staticRenderFns } from "./eyeBiologyTest.vue?vue&type=template&id=95953f9a&scoped=true&"
import script from "./eyeBiologyTest.vue?vue&type=script&lang=js&"
export * from "./eyeBiologyTest.vue?vue&type=script&lang=js&"
import style0 from "./eyeBiologyTest.vue?vue&type=style&index=0&id=95953f9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95953f9a",
  null
  
)

export default component.exports